import {
  UserAddOutlined,
  UserOutlined,
  MailOutlined,
  LockOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { Button, FloatButton, Form, Input, Modal, Select, Checkbox, Tag } from "antd";
// import "./UserComponent.css";
import "../../GlobalCss/SPF/UserComponent.css";
import { useState, useEffect } from "react";
import { CreateUser } from "../../Repository/UserManagementRepository";
import { SuccessMessage } from "../../Utils/Utils";
import { useDispatch } from "react-redux";
import { GetUsersDataAction } from "../../redux/UserManagementRedux/UserManagementAction";
import { GetUsers } from "../../Repository/UserManagementRepository";
import axios from "axios";
import { BaseUrl, FormConfig } from "../../Repository/BaseRepository";
import Cookies from "js-cookie";

const UserCreation = () => {
  const [ShowCreateUser, setShowCreateUser] = useState(false);
  const { Option } = Select;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);
  const [captchaSrc, setCaptchaSrc] = useState(""); // URL for the CAPTCHA image
  const [captchaInput, setCaptchaInput] = useState("");
  const [error, setError] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const jwtToken = Cookies.get("jwt_token");
  const tagRender = (props) => {
    const { label, closable, onClose } = props;

    return (
      <Tag
        color="blue"
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  };

  // Fetch CAPTCHA image from backend
  const fetchCaptcha = async () => {
    try {
      const response = await axios.get(`${BaseUrl}captcha/GetCaptcha`, {
        ...FormConfig
      });

      if (response.data.captcha) {
        const base64Captcha = response.data.captcha;
        setCaptchaSrc(`data:image/png;base64,${base64Captcha}`);
        setCaptchaInput(""); // Clear previous user input
        setError(""); // Clear any previous errors
      } else {
        throw new Error("Failed to fetch CAPTCHA");
      }
    } catch (error) {
      console.error("Error fetching CAPTCHA:", error.response || error.message);
      setError("Failed to fetch CAPTCHA. Please try again.");
    }
  };




  // Fetch users and roles data
  const fetchUserData = async () => {
    try {
      const usersData = await GetUsers();
      const allRoles = usersData.flatMap(user =>
        user.Role.split(",").map(r => r.trim())
      );
      const uniqueRoles = [...new Set(allRoles)];
      setRoles(uniqueRoles);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };


  // Fetch users and CAPTCHA on component mount
  useEffect(() => {
    fetchUserData();
    fetchCaptcha();
  }, []);

  // Handle user creation
  const HandleCreateUser = async (values) => {
    if (!captchaInput.trim()) {
      setError("CAPTCHA is required.");
      return;
    }
    try {
      // Validate CAPTCHA via backend
      const captchaValidation = await axios.post(
        `${BaseUrl}captcha/validate`,
        { UserCaptcha: captchaInput }, // Send JSON object
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${jwtToken}`
          },
        }
      );

      console.log("CAPTCHA Validation Response:", captchaValidation.data);

      if (!captchaValidation.data.success) {
        // Backend returns a failure, display the error message
        setError("Invalid CAPTCHA");
        fetchCaptcha(); // Regenerate CAPTCHA
        return; // Stop further execution
      }

      // Proceed with user creation if CAPTCHA is valid
      values["domain"] = "spectraforce";
      values["Rg_Id"] = 0;
      if (Array.isArray(values.Role)) {
        values.Role = values.Role.join(',');
      }
      const Response = await CreateUser(values);

      if (Response != null) {
        setShowCreateUser(false);
        setSelectedRoles([]);
        SuccessMessage(Response);
        dispatch(GetUsersDataAction()); // Refresh user data in the state
      }

      form.resetFields();
      fetchCaptcha(); // Regenerate CAPTCHA
    } catch (error) {
      console.error("Error during CAPTCHA validation or user creation:", error);
      setError(error.response?.data?.message || "Invalid CAPTCHA. Please try again.");
      fetchCaptcha();
    }
  };


  // Cancel user creation
  const HandleCancelUserCreation = () => {
    setShowCreateUser(false);
    setSelectedRoles([]);
    form.resetFields();
    fetchCaptcha(); // Reset CAPTCHA when modal closes
    setError("");
  };

  return (
    <div className="User-Creation-Container FlexingRow">
      <FloatButton
        tooltip={<div>Add New User</div>}
        icon={<UserAddOutlined className="User-Float-Icon" />}
        type="default"
        className="User-Float-Button"
        onClick={() => setShowCreateUser(true)}
      />

      <Modal open={ShowCreateUser} onCancel={HandleCancelUserCreation} footer={false}>
        <div className="centered-content">Create User</div>
        <Form form={form} onFinish={HandleCreateUser}>
          <Form.Item
            name="First_Name"
            rules={[
              { required: true, message: " " },
              {
                pattern: /^[^\s]+(\s+[^\s]+)*$/,
                message: "First name cannot contain only spaces.",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="First Name"
              prefix={<UserOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item
            name="Last_Name"
            rules={[
              { required: true, message: " " },
              {
                pattern: /^[^\s]+(\s+[^\s]+)*$/,
                message: "Last name cannot contain only spaces.",
              },
            ]}
          >
            <Input
              size="large"
              placeholder="Last Name"
              prefix={<UserOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item name="Email" rules={[{ required: true, message: " " }]}>
            <Input
              size="large"
              placeholder="Email"
              type="Email"
              prefix={<MailOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          {/* <Form.Item name="Password" rules={[{ required: true, message: " " }]}>
            <Input.Password
              size="large"
              placeholder="Password"
              prefix={<LockOutlined className="User-Creation-Icons" />}
            />
          </Form.Item> */}
          <Form.Item
            name="Password"
            rules={[
              { required: true, message: " " },
              {
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                message:
                  "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder="Password"
              prefix={<LockOutlined className="User-Creation-Icons" />}
            />
          </Form.Item>
          <Form.Item name="Role" rules={[{ required: true, message: "" }]}>
            <Select
              mode="multiple"
              size="large"
              placeholder="Select Role"
              value={selectedRoles}
              onChange={setSelectedRoles}
              tagRender={tagRender} // 👈 Renders selected tags
              dropdownRender={() => (
                <div>
                  {roles.map((role) => {
                    const isSuperUserSelected = selectedRoles.includes("Super User");
                    const isDisabled = isSuperUserSelected && role !== "Super User";

                    return (
                      <div key={role} style={{ padding: "5px 12px" }}>
                        <Checkbox
                          checked={selectedRoles.includes(role)}
                          disabled={isDisabled}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            let updatedRoles;

                            if (checked) {
                              updatedRoles =
                                role === "Super User"
                                  ? ["Super User"]
                                  : [...selectedRoles, role];
                            } else {
                              updatedRoles = selectedRoles.filter((r) => r !== role);
                            }

                            setSelectedRoles(updatedRoles);
                            form.setFieldsValue({Role:updatedRoles});
                          }}
                        >
                          {role}
                        </Checkbox>
                      </div>
                    );
                  })}
                </div>
              )}
            />
          </Form.Item>
          {/* CAPTCHA Section */}
          <div
            style={{
              marginBottom: "3%",
              fontSize: "120%",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "2%",
              borderRadius: "5px",
            }}
          >
            {/* CAPTCHA Image */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={captchaSrc}
                alt="CAPTCHA"
                style={{
                  border: "1px solid #ccc",
                  marginRight: "10px",
                  width: "200px",
                  height: "60px",
                }}
              />
              <ReloadOutlined
                style={{ fontSize: "120%", cursor: "pointer" }}
                onClick={fetchCaptcha}
              />
            </div>

            {/* CAPTCHA Input */}
            <Input
              placeholder="Enter CAPTCHA"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              style={{ width: "50%" }}
            />
          </div>

          {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

          <div className="centered-content">
            <Button
              style={{
                backgroundColor: "#3B52DF",
                color: "#fff",
                borderColor: "#3B52DF",
              }}
              htmlType="submit"
            >
              Add User
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default UserCreation;
